import { intelligentPhotoCaptureConstants } from '../constants';
/**
 * PhotoCapture Estimated Summary File Info Actions
 * These actions manage uploaded files in the Summary workflow
 */
export const INTELLIGENT_PHOTO_CAPTURE_ADD_ESTIMATED_SUMMARY_FILE_INFO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ADD_ESTIMATED_SUMMARY_FILE_INFO`;
export const INTELLIGENT_PHOTO_CAPTURE_CLEAR_ESTIMATED_SUMMARY_FILES_INFO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_CLEAR_ESTIMATED_SUMMARY_FILES_INFO`;
/**
 * Action creator to add estimated summary file info
 * @param fileInfo - The file info to add to the store
 */
export const photoCaptureIntelligentAddEstimatedSummaryFileInfoAction = (fileInfo) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ADD_ESTIMATED_SUMMARY_FILE_INFO,
    payload: { fileInfo }
});
/**
 * Action creator to clear all estimated summary files info
 */
export const photoCaptureIntelligentClearEstimatedSummaryFilesInfoAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_CLEAR_ESTIMATED_SUMMARY_FILES_INFO,
    payload: null
});
//# sourceMappingURL=photoCaptureEstimatedSummaryFileInfoAction.js.map